import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFandangoComponent } from './simple-icons-fandango.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFandangoComponent ],
    exports:      [ SimpleIconsFandangoComponent ],
    bootstrap:    []
})
export class SimpleIconsFandangoModule {}
